export default __webpack_public_path__ + "static/media/serveIT.be0f3b74.svg";